




import { HTMLAttributes, ReactElement } from "react";

interface Props extends HTMLAttributes<HTMLElement> {
    color?: string;
}
    
     function ArrowBack({ color }: Props): ReactElement {

    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g>
<path fillRule="evenodd" clipRule="evenodd" d="M12 22C6.4772 22 2 17.5228 2 12C2 6.47715 6.4772 2 12 2C17.5229 2 22 6.47715 22 12C22 17.5228 17.5229 22 12 22ZM14.0303 8.46967C13.7374 8.17678 13.2626 8.17678 12.9697 8.46967L9.9697 11.4697C9.6768 11.7626 9.6768 12.2374 9.9697 12.5303L12.9697 15.5303C13.2626 15.8232 13.7374 15.8232 14.0303 15.5303C14.3232 15.2374 14.3232 14.7626 14.0303 14.4697L11.5607 12L14.0303 9.53033C14.3232 9.23744 14.3232 8.76256 14.0303 8.46967Z" fill="black"/>
</g>
</svg>
    );
}

export default ArrowBack;